
<template>
    <rkm-form ref="Form">
        <box-alteracao
            ref="boxAlteracao"
            :data="{ initials, form, model }"
            @handleStatusAgendado="handleStatusAgendado"
        />
    </rkm-form>
</template>

<script>
import { mapActions } from 'vuex'

import BoxAlteracao from '@/components/exame-imagem/alteracao-exame-finalizado/components/Form'

import { repository, error, object, data, stringCase } from '@/mixins'

//Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

export default {
    components: { BoxAlteracao },
    created() {

        this.repositories = {
            alteracao: this.getConectaSusRepository('exameImagem.alteracaoExameFinalizado')
        }
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        enums: {
            statusFechamento
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save(){

            this.$refs.boxAlteracao.save()
        },
        handleStatusAgendado(value){

            this.handleStatus = value
        }
    },
    mixins: [repository, error, object, data, stringCase]
}
</script>